"use strict";

PF.Popup = class Popup extends PF.Widget
	{
	static get options()
		{
		return {
			dom: {
				popupContainer: app.dom.app,
				anchor: PF.Dom.Node.findOne('body'),
				content: undefined
			},
			html: PF.Popup.templates,
			background: true,
			linkTo: [[100, 0], [100, 100], [0, 0], [0, 100]],     //%
			linkBy: [[0, 0], [0, -100], [-100, 0], [-100, -100]], //%
			shift: [[5, 0], [5, 0], [-5, 0], [-5, 0]], //px
			cascade: true,
			windowIndent: 0,
			skin: '',
			positionTrait: PF.Popup.Position,
		};
		}

	static get templates()
		{
		return {
			popup: `
				<div class="pf-popup" pf="popup">
					<div class="pf-background" pf="background"></div>
					<div class="pf-container" pf="container"></div>
				</div>
				`,
			// content: ``
		};
		}

	init()
		{
		this.state = 'init';
		this.useTrait(this.positionTrait);
		this.createDom();
		this.binds();
		this.close();
		}

	createDom()
		{
		this.dom.loads(this.html);
		this.dom.container.append(this.dom.content);
		this.dom.popupContainer.append(this.dom.popup);
		this.dom.window = new PF.Dom.Node(document);

		if (this.background === false)
			{
			this.dom.background.hide();
			}
		}

	binds()
		{
		this.displayObs = new PF.Observer(this.dom.popup, this.displayFinish.bind(this));
		this.contentObs = new PF.Observer(this.dom.container, this.setPosition.bind(this));

		this.dom.background.on('click', this.beforeClose.bind(this));
		}

	open()
		{
		if (this.state === 'close')
			{
			this.state = 'opening';
			this.contentObs.stop();
			this.displayObs.start();
			this.dom.popup.css('display', 'block');
			this.trigger('opening');
			this.dom.window.trigger('resize.pf-popup');
			this.dom.window.on('resize.pf-popup', this.setPosition);
			}
		}

	displayFinish()
		{
		this.state = 'open';
		this.displayObs.stop();
		this.setPosition([], null, true);
		this.dom.background.css('opacity', 1);
		this.dom.container.css('opacity', 1);
		this.contentObs.start();
		this.trigger('opened');
		}

	beforeClose()
		{
		this.close();
		}

	close()
		{
		if (this.state === 'open' || this.state === 'init')
			{
			this.state = 'close';
			this.trigger('closing');
			this.contentObs.stop();
			this.dom.window.off('resize.pf-popup');
			this.dom.background.css('opacity', 0);
			this.dom.popup.css('display', 'none');
			console.log('hide popup');
			this.dom.container.css('opacity', 0);
			this.trigger('closed');
			}
		}

	};

PF.Popup.Position = class PopupPosition extends PF.Trait
	{
	initTrait()
		{
		this.p = {};
		}

	setPosition(mutations = [], observer = null, forse = false)
		{
		if (!this.isSetNeed(forse))
			{
			return;
			}

		let toCenter = true;
		let p;
		for (let i = 0; i < this.linkTo.length && toCenter; i++)
			{
			p = this.calculate(this.linkTo[i], this.linkBy[i], this.shift[i]);
			toCenter = !this.check(p);
			}
		if (toCenter)
			{
			p = this.toCenter();
			}
		this.p = p;
		this.dom.container.css({top: p.top + 'px'});
		this.dom.container.css({left: p.left + 'px'});

		this.width = this.dom.container.width();
		this.height = this.dom.container.height();

		this.trigger('set-position');
		}

	isSetNeed(forse)
		{
		if (this.state !== 'open')
			{
			return false;
			}
		if (forse)
			{
			return true;
			}
		if (this.isSizeChanged() || !this.check(this.p))
			{
			return true;
			}
		return false;
		}

	toCenter()
		{
		return this.calculate([0, 50], [0, -50], [0, 0], this.dom.popupContainer);
		}

	calculate(linkTo, linkBy, shift, domAnchor = this.dom.anchor)
		{
		let p = {
			top: domAnchor.offset().top,
			left: domAnchor.offset().left,
		};
		p.top += (linkTo[0] / 100) * domAnchor.outerHeight(true);
		p.top += shift[0];
		p.top += (linkBy[0] / 100) * this.dom.container.outerHeight();
		p.left += (linkTo[1] / 100) * domAnchor.outerWidth(true);
		p.left += shift[1];
		p.left += (linkBy[1] / 100) * this.dom.container.outerWidth();
		return p;
		}

	check(p)
		{
		let maxTop = p.top + this.dom.container.outerHeight(true) + this.windowIndent;
		let maxLeft = p.left + this.dom.container.outerWidth(true) + this.windowIndent;
		let body = PF.Dom.Node.findOne('body');
		return this.windowIndent <= p.top && maxTop <= body.height() && this.windowIndent <= p.left && maxLeft <= body.width();
		}

	isSizeChanged()
		{
		return this.width !== this.dom.container.width() || this.height !== this.dom.container.height();
		}

	};